module.exports = __webpack_public_path__ + "img/11.5dc9b2ed.png";